
// Módulo funcional: Ventas / Reporte de Refacciones (catálogo compartido)
export const CANTIDAD_MOSTRAR_OPCIONES = ["10", "20", "50", "100", "200", "todos"];
